import React from "react";
import SearchTable from "../../../../components/common/SearchTable";

export const TABLE_SEARCH = {
  cylinder: ["cylinder_no"],
  station: ["dispatched_from_station"],
  vehicle: ["vehicle_no"]
};

export const SearchTransitCylinder = () => {
  return (
    <div className="w-full white-card">
      <SearchTable
        searchCategories={TABLE_SEARCH}
        placeholder="Search by Cylinder, Station, Vehicle"
        width="w-full"
      />
    </div>
  );
};
